import axios from './financeiroApi';

const reguaCobrancaApi = () => {
  const getPathReguaCobranca = () => {
    return `/api/v1/backend/regua-cobranca`;
  };

  const getParams = (Filtro) => {
    let newFiltro;
    if (Filtro?.filtroAvancado) {
      newFiltro = {
        ...Filtro,
        ...Filtro.filtroAvancado,
      };
      delete newFiltro.filtroAvancado;
    } else {
      newFiltro = Filtro;
    }
    return newFiltro;
  };

  return {
    buscarReguasCobrancas: async (filtro) => {
      const url = `${getPathReguaCobranca()}`;
      return axios.get(url, { params: getParams(filtro) });
    },
    buscarPassos: async (reguaCobrancaId, search) => {
      const url = `${getPathReguaCobranca()}/${reguaCobrancaId}/passos`;
      return axios.get(url, { params: getParams(search) });
    },
    cadastrarReguaCobranca: async (reguaCobrancaRequest) => {
      const url = `${getPathReguaCobranca()}`;
      return axios.post(url, reguaCobrancaRequest);
    },
    buscarReguaCobrancaPorId: async (reguaCobrancaId) => {
      const url = `${getPathReguaCobranca()}`;
      return axios.get(`${url}/${reguaCobrancaId}`);
    },
    atualizarReguaCobranca: async (reguaCobrancaRequest) => {
      const url = `${getPathReguaCobranca()}/${reguaCobrancaRequest.id}`;
      return axios.put(url, reguaCobrancaRequest);
    },
    ativarInativarReguaCobranca: async (reguaCobrancaId, ativo) => {
      const url = `${getPathReguaCobranca()}/ativar-inativa/${reguaCobrancaId}?ativo=${ativo}`;
      return axios.patch(url);
    },
    excluirReguaCobranca: (filtro) => {
      return axios.delete(getPathReguaCobranca(), { data: filtro });
    },
    buscarTemplateMail: async () => {
      const url = `${getPathReguaCobranca()}/buscar-template`;
      return axios.get(url);
    },
    montarCardReguaCobranca: async (reguaCobrancaId, competencia) => {
      const url = `${getPathReguaCobranca()}/montar-card/${reguaCobrancaId}?competencia=${competencia}`;
      return axios.get(url);
    },
    buscarOcorrenciaClientes: async (clientesIds) => {
      const url = `${getPathReguaCobranca()}/buscarOcorrencias?clientesIds=${clientesIds}`;
      return axios.get(url);
    },
  };
};

export { reguaCobrancaApi };
